const standards = [
  { level: "CEN B4", colombian: "Blindaje 1", threat: "Handgun Protection", ammunition: ".357 Magnum, .44 Magnum", useCase: "Executive transport, low-risk areas" },
  { level: "CEN B6", colombian: "Blindaje 2/2+", threat: "Assault Rifle Protection", ammunition: "7.62x51mm NATO, AK-47", useCase: "VIP protection, high-risk areas" },
  { level: "CEN B7", colombian: "Blindaje 3+", threat: "High-Power Rifle Protection", ammunition: "7.62x51mm AP, .30-06 AP", useCase: "Maximum civilian protection" },
  { level: "VPAM VR9/10", colombian: "Blindaje Militar", threat: "Military-Grade Protection", ammunition: "Multiple high-velocity rounds", useCase: "Military and special operations" },
];

function ArmorStandards() {
  return (
    <section className="section armor-standards">
      <div className="container">
        <h2 className="section-title">International Armor Protection Standards</h2>
        <p className="section-subtitle">
          Understanding protection levels according to European CEN and international standards
        </p>

        <div className="standards-table">
          <table>
            <thead>
              <tr>
                <th>Protection Level</th>
                <th>Colombian Standard</th>
                <th>Threat Protection</th>
                <th>Typical Ammunition</th>
                <th>Use Case</th>
              </tr>
            </thead>
            <tbody>
              {standards.map((row) => (
                <tr key={row.level}>
                  <td><strong>{row.level}</strong></td>
                  <td>{row.colombian}</td>
                  <td>{row.threat}</td>
                  <td>{row.ammunition}</td>
                  <td>{row.useCase}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}

export default ArmorStandards;
